import React from 'react';
import * as PropTypes from 'prop-types';
import TIPimg01 from 'dc/TIPimg01';
import Spa16 from 'dc/Spa16';
import {
  ImageContainer,
  InfoWrapper,
  TranslateTitle,
  TranslateText,
} from './elements';

function ChStPrt1(props) {
  return (
    <div className={props.className}>
      <ImageContainer>
        <TIPimg01
          backgroundSize={'contain'}
          height="180px"
          width="100%"
          image={props.imageUrl}
        />
      </ImageContainer>
      <InfoWrapper>
        <TranslateTitle>{props.translate_title_text}</TranslateTitle>
        <Spa16 size={'double'} />
        <TranslateText>{props.text}</TranslateText>
      </InfoWrapper>
    </div>
  );
}

ChStPrt1.propTypes = {
  className: PropTypes.string,
  imageUrl: PropTypes.string,
  text: PropTypes.string,
  translate_title_text: PropTypes.string,
};

export default ChStPrt1;
